import { useAggregationSubscription } from '@bloobirds-it/plover';
import { BOBJECT_TYPES } from '../../constants/bobject';
import { LEAD_FIELDS_LOGIC_ROLE, LEAD_SOURCE_LOGIC_ROLES } from '../../constants/lead';

export const getAggregationQuery = () => ({
  query: {
    [LEAD_FIELDS_LOGIC_ROLE.SOURCE]: LEAD_SOURCE_LOGIC_ROLES.INBOUND,
  },
  queries: [
    {
      [LEAD_FIELDS_LOGIC_ROLE.MQL]: '__MATCH_EMPTY_ROWS__',
      [LEAD_FIELDS_LOGIC_ROLE.SAL]: '__MATCH_EMPTY_ROWS__',
    },
    {
      [LEAD_FIELDS_LOGIC_ROLE.SAL]: '__MATCH_EMPTY_ROWS__',
      [LEAD_FIELDS_LOGIC_ROLE.MQL]: 'LEAD__MQL__ACCEPTED',
    },
  ],
  formFields: false,
  aggregations: [LEAD_FIELDS_LOGIC_ROLE.SOURCE],
});

export const useInboundGlobalAggregation = () => {
  const { data } = useAggregationSubscription(getAggregationQuery(), BOBJECT_TYPES.LEAD);
  return data?.data?.contents[0]?.value;
};
